<h1 ev-dialog-title data-testid="gps-error-title">{{ languageService.languageJSON.GPSErrorDialog_Title }}</h1>

<div ev-dialog-content class="scrollable" data-testid="gps-error-container">
  <div class="gps-error-content">
    @if (!fbAndroid && !fbIos) {
      <app-modal-option-panel>
        <img alt="" class="gps-error-icon" [src]="'assets/icons/' + settingsService.getMap().Skin + '/ui/start_icon.svg'" />
        <ol class="gps-error-steps" data-testid="gps-error-steps-list">
          @for (informationTextElement of informationText; track informationTextElement) {
            <li [innerHtml]="informationTextElement"></li>
          }
        </ol>
      </app-modal-option-panel>
    }

    @if (fbAndroid || fbIos) {
      <app-modal-option-panel>
        <div class="gps-error-fb">
          @if (fbAndroid) {
            <p class="gps-error-message" data-testid="gps-error-fb-android-text" [innerHtml]="languageService.languageJSON.GPSErrorDialog_Facebook_Info_Android"></p>
            <button type="button" class="ev-plain-button gps-error-download-icon"
              data-testid="gps-error-google-play-btn"
              (click)="openUrl('https://play.google.com/store/apps/details?id=com.gpstuner.evnavigation')">
              <img alt="Google Play"
                [src]="'assets/icons/default/social/' + languageService.getStoreBadgeLanguage() + '/google_play_button.svg'" />
            </button>
          }
          @if (fbIos) {
            <p class="gps-error-message" data-testid="gps-error-fb-ios-text" [innerHtml]="languageService.languageJSON.GPSErrorDialog_Facebook_Info_Ios"></p>
          }
        </div>
      </app-modal-option-panel>
    }
  </div>
</div>

<div ev-dialog-actions>
  <button class="ev-button primary" mat-button data-testid="gps-error-ok-btn" (click)="accept()">{{ languageService.languageJSON.Global_Ok }}</button>
</div>
